import * as React from "react";
import Blog from "./index";
import { StyleRoot } from "radium";
import { Route } from "react-router-dom";
import Asset from "../../shared/components/asset";
import { blogRoutes } from "../../shared/constants";
import { Category } from "./components/category";
import { Post } from "./components/post";
import { PostPreview } from "./components/postPreview";
export default (function (props) {
    return (React.createElement(StyleRoot, { radiumConfig: {
            userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/537.36 (KHTML, like Gecko)          Chrome/64.0.3282.186 Safari/537.36",
        } },
        React.createElement(Asset, { src: "blog.js" }),
        React.createElement(Asset, { src: "blog.css" }),
        React.createElement("div", null,
            React.createElement(Route, { path: blogRoutes.show, exact: true, render: function () { return (React.createElement(Blog, { featuredPosts: props.featuredPosts, latestPosts: props.latestPosts, postHighlight: props.postHighlight, catBehindTheScenes: props.catBehindTheScenes, catCommunity: props.catCommunity, catPathfinders: props.catPathfinders, catQuizCompetitions: props.catQuizCompetitions, catWonderings: props.catWonderings })); } }),
            React.createElement(Route, { path: blogRoutes.showPost, render: function (_a) {
                    var match = _a.match;
                    return (React.createElement(Post, { post: props.blogPost, next: props.next, previous: props.previous, trendingPosts: props.trendingPosts, recommendedPosts: props.recommendedPosts }));
                } }),
            React.createElement(Route, { path: blogRoutes.previewPost, render: function (_a) {
                    var match = _a.match;
                    return (React.createElement(PostPreview, { post: props.previewPost, trendingPosts: props.trendingPosts, recommendedPosts: props.recommendedPosts }));
                } }),
            React.createElement(Route, { path: blogRoutes.showCategory, render: function (_a) {
                    var match = _a.match;
                    return (React.createElement(Category, { posts: props.blogPosts, category: props.blogPosts[0].categories
                            .find(function (cat) { return cat.id === props.categoryId; }) }));
                } }),
            React.createElement(Route, { path: blogRoutes.showCategoryLatest, exact: true, render: function () { return (React.createElement(Category, { posts: props.categoryLatest })); } }))));
});



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/app.tsx
// module id = s5En
// module chunks = 3